<template>
  <div class="wide-wrapper">
    <div class="contentSection">
      <div class="col-md-12 text-left">
        <div class="row">
          <div class="col-md-3 text-center d-flex justify-content-center">
            <div class="align-self-center">
              <div class="image-upload" v-if="!image">
                <label for="file-input">
                  <img id="img" class="pointer" src="@/assets/imgs/img-placeholder.png">
                </label>
                <input
                  class="validate"
                  type="file"
                  id="file-input"
                  @change="$emit('handlefile', $event)"
                  accept="image/*"
                >
              </div>
              <div class="image-preview" v-else>
                <img :src="image" alt>
              </div>
            </div>
          </div>
          <div class="col-md-6 d-flex flex-column align-items-start">
            <div class="w-100">
              <h2>
                <input
                  class="hidden text-left p-0 w-100"
                  placeholder="Headline"
                  v-model="offer.headline"
                  type="text"
                  required
                >
              </h2>
            </div>
            <div class="w-100">
              <span>
                <textarea
                  class="hidden text-left p-0 w-100"
                  placeholder="Offer text"
                  style="white-space:wrap;overflow:auto;min-height:60px;resize:none;"
                  v-model="offer.tagline"
                  type="text"
                  required
                ></textarea>
              </span>
            </div>
          </div>
          <div class="col-md-3">
            <input
              style
              v-model="offer.linkOutButtonText"
              class="greenBtn hidden mb-3 w-100"
              type="text"
              required
            >
            <br>
            <input
              style
              v-model="offer.nextButtonText"
              class="greyBtn hidden w-100"
              type="text"
              required
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  props: ['offer', 'image']

}
</script>
<style lang="scss" scoped>
.wide-wrapper {
  .tokenBtn {
    padding: 8px 16px;
    line-height: 18px;
    font-size: 16px;
  }
  .hidden-button {
    background-color: $container-bg;
    color: $mainColor;
    &:hover {
      background-color: $container-bg;
    }
  }
  .fa-link:before {
    margin: 10px;
  }
  .image-upload,
  .placeholder {
    input {
      display: none;
    }
  }
  .hidden {
    text-align: center;
    border: none;
    outline: none;
    h2 {
      font-size: 26px;
      font-weight: 200;
    }
  }
  .blend {
    background-color: #f2f2f2;
  }
}
</style>
